/* eslint-disable no-shadow, import/no-named-as-default-member */
import types from './types';

export function state() {
  return {
    [types.UPC]: {},
    [types.COLORS]: {},
    [types.SELECTED_COLOR]: {},
    [types.PRICE]: {},
    [types.SIZES]: {},
    [types.SELECTED_SIZE]: {},
    [types.TYPE]: {},
    [types.SELECTED_TYPE_ID]: {},
  };
}

export const mutations = {
  set(state, { scope, key, value }) {
    state[scope][key] = value;
  },
};
